import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* import { ProvidersInterceptor } from './interceptors/providers.interceptor'; */
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    MatButtonModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatSelectModule,
    MatDialogModule,
    CommonModule,
    FormsModule,
    RouterModule
  ],
  providers: [
      /* ProvidersInterceptor */
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MobileMenuComponent
   ],
  declarations: [ HeaderComponent, FooterComponent, MobileMenuComponent ]
})
export class CoreModule { }
